import { getCountryCurrencyCode } from "@/utils/countryAdapter";

export default {
  name: "TwoPhaseOtpLogicMixin",
  props: {
    pageData: Object,
  },
  data() {
    return {
      otpCode: "",
      submitting: false,
      isLoading: true,
      isConfirming: false,
      isOver: false,
      isFailed: false,
      failMessage: "",
      pollTimer: null,
    };
  },
  computed: {
    countryInfo() {
      return this.pageData?.configData?.countryInfoVO;
    },
    currencyCode() {
      return getCountryCurrencyCode(this.countryInfo, "AOA");
    },
    formattedPaymentAmount() {
      return this.pageData?.paymentData?.amount;
    },
    userMobileDisplay() {
      const mobile = this.pageData?.paymentData?.customerAccountNumber;
      if (!mobile) return "";
      if (mobile.length >= 8) {
        return mobile.slice(0, 3) + "****" + mobile.slice(-2);
      }
      return mobile;
    },
    // checkoutStatus >= 30 表示 sys/initialize 已被调用（precreate 完成）
    alreadyInitiated() {
      const status = this.pageData?.paymentData?.checkoutStatus;
      return status && (status.value >= 30 || status === "THIRD_RESPONSE_SUCCESS");
    },
  },
  methods: {
    onOtpInput(e) {
      this.otpCode = e.target.value.replace(/[^0-9]/g, "").slice(0, 6);
    },
    async submitOtp() {
      if (this.otpCode.length < 6 || this.submitting) return;
      this.submitting = true;
      try {
        const res = await this.$http.confirmPayment({
          platformReference: this.$route.params.platformReference,
          otp: this.otpCode,
        });
        if (res.code == "200" && res.data.success) {
          this.isConfirming = true;
          this.startPolling();
        } else {
          this.isFailed = true;
          const msg = res.data?.message;
          if (res.code == "200" && msg) {
            // 200 + success=false → 接口正常返回失败（如 OTP 错误）
            this.failMessage = msg;
          } else {
            this.failMessage = "Payment failed";
          }
        }
      } catch (e) {
        // HTTP 异常（网络错误或服务端抛异常）
        const data = e?.response?.data;
        const msg = data?.msg || data?.message || e.message;
        this.isFailed = true;
        this.failMessage = msg || "Payment failed";
      } finally {
        this.submitting = false;
      }
    },
    startPolling() {
      let that = this;
      this.pollTimer = setInterval(async () => {
        if (!that.pageData?.paymentData?.apiKey) return;
        try {
          const res = await that.$http.transactionsQuery({
            apiKey: that.pageData.paymentData.apiKey,
            platformReference: that.$route.params.platformReference,
          });
          const status = res.data?.paymentStatus;
          if (status === "PAID") {
            that.isOver = true;
            that.isConfirming = false;
            clearInterval(that.pollTimer);
            that.pollTimer = null;
            that.$emit("refreshData");
          } else if (status === "FAILED" || status === "EXPIRED") {
            that.isFailed = true;
            that.isConfirming = false;
            that.failMessage = "Payment " + status.toLowerCase();
            clearInterval(that.pollTimer);
            that.pollTimer = null;
          }
        } catch (e) {
          // silently ignore
        }
      }, 3000);
    },
    back() {
      window.opener = null;
      window.open("", "_self");
      window.close();
    },
    async ensureInitiated() {
      // 如果 sys/initialize 已被调用过（checkoutStatus >= THIRD_RESPONSE_SUCCESS），跳过
      if (this.alreadyInitiated) {
        return true;
      }
      // 否则调用 sys/initialize 触发 precreate
      try {
        const res = await this.$http.v1SdkSysInitialize({
          platformReference: this.$route.params.platformReference,
        });
        if (res.code == "200") {
          return true;
        }
        // ORDER_ALREADY_EXISTS 也认为已初始化成功
        if (res.code == "500" && res.message && res.message.includes("already exists")) {
          return true;
        }
      } catch (e) {
        // 某些情况下服务端返回已存在错误 → 视为已初始化
        if (e.message && e.message.includes("already")) {
          return true;
        }
      }
      return false;
    },
  },
  async mounted() {
    const ok = await this.ensureInitiated();
    if (!ok) {
      this.isFailed = true;
      this.failMessage = "Failed to initialize payment";
      return;
    }
    this.isLoading = false;
    // 通知父组件开始全局 polling
    this.$emit("paymentInitiated");
  },
  beforeDestroy() {
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
    }
  },
};
